module.exports = __webpack_public_path__ + "img/cbly1.50d0786d.gif";